// extracted by mini-css-extract-plugin
module.exports = {"label":"dateTime_label__5f4D0 font-bold inline-block mr-2","content":"dateTime_content__zLJ3i inline-block"};